// extracted by mini-css-extract-plugin
export default {"wrapper":"A_CapsuleUserAvatar_wrapper__8IO9A"};